import { render } from "./VideoElement.vue?vue&type=template&id=1f7afba5&scoped=true"
import script from "./VideoElement.vue?vue&type=script&lang=js"
export * from "./VideoElement.vue?vue&type=script&lang=js"

import "./VideoElement.vue?vue&type=style&index=0&id=1f7afba5&scoped=true&lang=css"

import exportComponent from "../../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7afba5"]])

export default __exports__